"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVICE_TYPE = void 0;
var DEVICE_TYPE;
(function (DEVICE_TYPE) {
    DEVICE_TYPE["ANDROID"] = "ANDROID";
    DEVICE_TYPE["IOS"] = "IOS";
})(DEVICE_TYPE || (exports.DEVICE_TYPE = DEVICE_TYPE = {}));
